import { Schema } from "effect";
import type { WorkspaceStorageFailure } from "./workspace-http.ts";
import type { RuntimeDependencyError } from "./dependency.ts";
import type { ImmutableTreeExecutionError, HostedTestArtifactError } from "./source.ts";
import type { StoredSourceVersionStorageError, WorkspaceBuildFailure } from "./runtime.ts";
export const HostedTestHttpError = /* @__PURE__ */ (() => {
  class HostedTestHttpError extends Schema.TaggedError<HostedTestHttpError>()("HostedTestHttpError", {
    status: Schema.Literals([400, 404, 405, 409, 502, 503]), message: Schema.String,
    allow: Schema.optionalKey(Schema.String)
  }) {}
  return HostedTestHttpError;
})();
export type HostedTestHttpError = InstanceType<typeof HostedTestHttpError>;
export const HostedTestIoError = /* @__PURE__ */ (() => {
  class HostedTestIoError extends Schema.TaggedError<HostedTestIoError>()("HostedTestIoError", { status: Schema.tag(500), message: Schema.String }) {}
  return HostedTestIoError;
})();
export type HostedTestIoError = InstanceType<typeof HostedTestIoError>;
export type HostedTestExecutionFailure = HostedTestHttpError | HostedTestIoError | ImmutableTreeExecutionError | HostedTestArtifactError | StoredSourceVersionStorageError | WorkspaceBuildFailure;
export type HostedTestHttpFailure = HostedTestExecutionFailure | WorkspaceStorageFailure | RuntimeDependencyError;
export const hostedTestInvalid = (message: string) => new HostedTestHttpError({ status: 400, message });
export const hostedTestMethodNotAllowed = (allow: string) => new HostedTestHttpError({ status: 405, message: "Method not allowed.", allow });
export const hostedTestMissing = (message: string) => new HostedTestHttpError({ status: 404, message });
export const hostedTestUnavailable = (message: string) => new HostedTestHttpError({ status: 503, message });
export const hostedTestConflict = (message: string) => new HostedTestHttpError({ status: 409, message });
export const hostedTestBadGateway = (message: string) => new HostedTestHttpError({ status: 502, message });
export const hostedTestIoFailure = () => new HostedTestIoError({ message: "Hosted-test dependency is unavailable." });
